import { type PagamentoWithDettaglioDTO } from '@framework/api-client/api/inquiries-compile/schemas/pagamentoWithDettaglioDTO.ts';

/**
 * Verifica se il pagamento prevede il metodo con Avviso di Pagamento
 * (PagoPA Modello 3, in modalità sincrona o asincrona).
 */
export function hasPaymentAlertMethod(
  payment: PagamentoWithDettaglioDTO,
): boolean {
  const hasBurdenPayment =
    payment.oneri?.some(
      o =>
        o.tipoOnere?.flPagamentoModello3 ||
        o.tipoOnere?.flPagamentoModello3Asincrono,
    ) ?? false;
  const hasQuotePayment =
    payment.preventivo?.tipoPagamento?.flPagamentoModello3 ?? false;
  return hasBurdenPayment || hasQuotePayment;
}

/**
 * Verifica se il pagamento utilizza il Modello 3 in modalità asincrona
 * lo IUV viene fornito in differita dal servizio.
 */
export function isPaymentAlertAsync(
  payment: PagamentoWithDettaglioDTO,
): boolean {
  return (
    payment.oneri?.some(o => o.tipoOnere?.flPagamentoModello3Asincrono) ?? false
  );
}

/**
 * Verifica se l'avviso di pagamento non è ancora disponibile: in modalità
 * asincrona il documento è scaricabile solo quando il servizio ha fornito
 * lo IUV.
 */
export function isPaymentAlertDocumentPending(
  payment: PagamentoWithDettaglioDTO,
): boolean {
  return isPaymentAlertAsync(payment) && !payment.iuv;
}
